<template>
  <v-container fluid class="pl-0">
    <v-row>
      <v-col :cols="showIndividualUserView ? 6 : 12">
        <v-card>
          <v-card-title>
            All Users
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="fas fa-search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="users"
            :search="search"
            :loading="loading"
            class="elevation-1"
            item-key="email"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100]
            }"
            @click:row="onRowClick"
          >
            <template v-slot:[`item.is_admin`]="{ item }">
              <v-chip v-if="item.is_admin" color="purple" size="small">Admin</v-chip>
            </template>
            <template v-slot:[`item.account_status`]= "{ item }">
              <v-chip :color="item.account_status === 'Active' ? 'green' : item.account_status === 'Pending' ? 'orange' : 'red'" dark>{{ item.account_status }}</v-chip>
            </template>
            <template v-slot:[`item.tier`]= "{ item }">
              <v-chip v-if="item.tier" color="primary" dark>{{ item.tier }}</v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="6" v-if="showIndividualUserView">
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-vue';
import { useRouter, useRoute } from 'vue-router'; // Import useRoute

export default {
  name: 'AllUsers',
  setup() {
    const { getAccessTokenSilently } = useAuth0();
    const router = useRouter();
    const route = useRoute(); // Get route instance
    const users = ref([]);
    const loading = ref(true);
    const search = ref('');

    const headers = [
      { title: 'Name', align: 'start', sortable: true, key: 'name' },
      { title: 'Email', key: 'email' },
      { title: 'Organization', key: 'organization' },
      { title: 'Tier', key: 'tier' },
      { title: 'Terms Version', key: 'terms_version' },
      { title: 'Account Status', key: 'account_status' },
      { title: 'Admin', key: 'is_admin', sortable: false },
    ];

    const fetchUsers = async () => {
      loading.value = true;
      try {
        const token = await getAccessTokenSilently();
        const response = await axios.get(`${process.env.VUE_APP_CBE_BASE_URL}/piccolo/admin/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        users.value = response.data;
      } catch (error) {
        console.error('Error fetching users:', error);
        // Handle error, maybe show a snackbar
      } finally {
        loading.value = false;
      }
    };

    const onRowClick = (event, { item }) => {
      if (item.auth0_id) {
        router.push({ name: 'IndividualUser', params: { id: item.auth0_id } });
      } else {
        console.error('User does not have an auth0_id:', item);
      }
    };

    // Computed property to determine if IndividualUser view should be shown
    const showIndividualUserView = computed(() => {
      return route.params.id !== undefined;
    });

    onMounted(fetchUsers);

    return {
      users,
      loading,
      search,
      headers,
      onRowClick,
      showIndividualUserView, // Expose to template
    };
  },
};
</script>